module.exports = __webpack_public_path__ + "img/logo.8069ac38.png";